import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../core/services/api.service';
import { DashboardData } from '../interface';


@Injectable({ providedIn: 'root' })
export class NotificationService extends ApiService {



  public getNotifications(): Observable<DashboardData> {
    return this.request({
      path: 'notifications',
      method: 'GET',
    })
  }



}
